import { config as developmentConfig } from "./environments/development";
import { config as productionConfig } from "./environments/production";
import { config as stagingConfig } from "./environments/staging";
import { config as testConfig } from "./environments/test";

export type AppConfig = {
  /** サーバーサイド（SSR）から API にアクセスする URL */
  apiUrl: string;
  /** クライアントサイド（ブラウザ）から API にアクセスする URL */
  publicApiUrl: string;
  /** 公開サイトの URL */
  siteUrl: string;
  /** 管理画面の URL */
  adminUrl: string;
};

const configs: Record<string, AppConfig> = {
  development: developmentConfig,
  staging: stagingConfig,
  production: productionConfig,
  test: testConfig,
};

function validateConfig(config: AppConfig, env: string): void {
  const required: (keyof AppConfig)[] = ["apiUrl", "publicApiUrl", "siteUrl", "adminUrl"];
  const missing = required.filter((key) => !config[key]);
  if (missing.length > 0) {
    throw new Error(`[app.config] 設定値が未設定です (env=${env}): ${missing.join(", ")}`);
  }
}

export function getConfig(): AppConfig {
  // ビルド時（next.config.ts）は APP_ENV のみ参照可能（NEXT_PUBLIC_APP_ENV は next.config.ts 自身が設定する）
  // クライアントサイド（ブラウザ）は NEXT_PUBLIC_APP_ENV のみ参照可能（APP_ENV は NEXT_PUBLIC_ なし）
  const env = process.env["NEXT_PUBLIC_APP_ENV"] || process.env["APP_ENV"] || "development";
  const config = configs[env] ?? developmentConfig;
  validateConfig(config, env);
  return config;
}
